// import WidgetType from '../enums/WidgetType'
// import CountType from '../enums/CountType'
// import WidgetUtil from './widgetUtil'
import { cloneDeep } from 'lodash'
import RunSearchVo from 'vo/action/RunSearch'
import { SortByOptionsStrings } from 'enums/SortByOptions'
import { SideBySideResult } from 'schemas/SideBySideResultSchema'
import { MediaDomainStrings } from 'enums/MediaDomain'
import { DocumentRetrievalResult } from 'schemas/DocumentRetrievalResultSchema'
import { DetectTypeStrings } from 'enums/DetectType'
import { PhotoConceptServiceProperty } from 'schemas/PhotoConceptServicePropertySchema'
import ServiceType, { ServiceTypeStrings } from '../enums/ServiceType'
import { SortByStrings } from '../enums/SortBy'
import ParamVo from '../vo/Param'
import ServicePropertyVo from '../vo/ServiceProperty'
import MeasureType, { MeasureTypeStrings } from '../enums/MeasureType'
import MetricSeries, { MetricSeriesStrings } from '../enums/MetricSeries'
import { PrecisionStrings } from '../enums/Precision'
import { isAllInsights } from './featureUtil'
import ServiceVo from '../vo/Service'
import ServiceResultVo from '../vo/ServiceResult'
import MetricResultVo from '../vo/MetricResult'
import PivotResultVo from '../vo/PivotResult'
import LogInfoVo from '../vo/LogInfo'
import postProcess from './action/insightCountUtil'
import { RunSearch } from '../schemas/action/RunSearchSchema'
import { SentenceInfo } from '../schemas/SentenceInfoSchema'
import { MetricTimeUnitStrings } from '../enums/MetricTimeUnit'
import { SupportedMetricSeriesStrings } from '../enums/SupportedMetricSeries'
import { AnnotatedMetricResult } from '../schemas/AnnotatedMetricResultSchema'
import { EntryData, ServiceResultWith } from '../schemas/ServiceResultSchema'
import { InsightCount } from '../schemas/action/InsightCountSchema'
import { PivotResult } from '../schemas/PivotResultSchema'
import { Service } from '../schemas/ServiceSchema'
import { CategoryStrings } from '../enums/Category'
import { Filter } from '../schemas/FilterSchema'
import { MeasureStrings } from '../enums/Measure'
import { Metric } from '../schemas/MetricSchema'
import { InsightCountOptions } from '../schemas/action/InsightCountOptionsSchema'
import getSortKey from './sortKeyUtil'

// function dayHourConverter(widgetSetting) {
//   let spec = {}
//   if (!widgetSetting.selectedTopic) {
//     return false // TODO: show topic inaccessible
//   }
//   const topicIds = [widgetData.selectedTopic.topicId]
//   const countType =
//     widgetSetting.countType ||
//     WidgetUtil.getDefaultCountTypeByAnalysisType(widgetSetting.analysisType)
//   spec.isAuthorBased_ = countType === CountType.AUTHORS

//   // get categories

//   //toFilter
// }

// function wordCloudConverter(widgetData) {
//   return widgetData
// }

// export function runSearchSpecConverter(widgetData) {
//   const widgetConverterMap = {
//     [WidgetType.DAY_HOUR]: dayHourConverter(widgetData),
//     [WidgetType.WORDCLOUD]: wordCloudConverter(widgetData)
//   }

//   return widgetConverterMap(widgetData.widgetType)
// }

const DEFAULT_SIZE_NEEDED = 500

export function genAudienceMapping(
  metricSeriesTypeList: MetricSeriesStrings[]
): Map<string, string> {
  // Below code should be for Audience Analysis only.
  const namesMap = new Map<string, string>()
  for (let i = 0; i < metricSeriesTypeList.length; i += 1) {
    let replaceMetricSeriesType
    switch (metricSeriesTypeList[i]) {
      case MetricSeries.POSITIVE_SENTIMENT:
        replaceMetricSeriesType = MetricSeries.POSITIVE_SENTIMENT_ON_UNIQUE_AUTHORS
        break
      case MetricSeries.NEGATIVE_SENTIMENT:
        replaceMetricSeriesType = MetricSeries.NEGATIVE_SENTIMENT_ON_UNIQUE_AUTHORS
        break
      case MetricSeries.PASSION:
        replaceMetricSeriesType = MetricSeries.PASSION_ON_UNIQUE_AUTHORS
        break
      case MetricSeries.NET_SENTIMENT:
        replaceMetricSeriesType = MetricSeries.NET_SENTIMENT_ON_UNIQUE_AUTHORS
        break
      default:
        break
    }
    if (replaceMetricSeriesType) {
      namesMap.set(replaceMetricSeriesType, metricSeriesTypeList[i])
      // FIXME: should not be mutating metricSeriesTypeList
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      metricSeriesTypeList[i] = replaceMetricSeriesType
    }
  }

  return namesMap
}

export function disableSmoothing(measures?: MeasureTypeStrings): boolean {
  return !!(
    measures?.includes(MeasureType.OVERALL_STAR_RATINGS_AVERAGE) ||
    measures?.includes(MeasureType.OVERALL_SURVEY_SCORES_AVERAGE)
  )
}

// type RunSearchVo = (service: any, namesMap?: Map<string, string>) => RunSearch

export function createMetric(
  dashboardId: number,
  dashboardName: string,
  precision: PrecisionStrings,
  topicIds: number[],
  filter: any,
  metricSeriesList: SupportedMetricSeriesStrings[],
  timeUnits: MetricTimeUnitStrings[],
  options?: any
): RunSearch {
  const service = ServiceVo()
  service.type = ServiceType.METRIC_VALUE
  service.parameters = ParamVo()
  service.properties = ServicePropertyVo()

  if (topicIds && topicIds.length > 0) {
    service.parameters.topicIds = topicIds
  }
  if (options && options.previewTopic) {
    service.parameters.topicOnTheFly = options.previewTopic
  }
  if (precision) {
    service.parameters.precision = precision
  }
  service.parameters.filter = filter
  service.properties.priority = 6

  let namesMap: Map<string, string> | undefined
  if (metricSeriesList) {
    service.properties.metricSeries = metricSeriesList

    if (options && options.isAudienceQuery) {
      namesMap = genAudienceMapping(metricSeriesList)
    }
  }
  service.properties.timeUnits = timeUnits

  if (options && options.metricCategory) {
    service.properties.metricCategory = options.metricCategory
  }
  if (options && options.extraInfo) {
    service.properties.extraInfo = options.extraInfo
  }
  if (options && options.forceNotScale) {
    service.properties.forceNotScale = options.forceNotScale
  }
  if (options && options.isYoutubeOnly) {
    service.properties.youTubeOnly = true
  }
  if (options?.smoothing === false) {
    service.properties.smoothing = options.smoothing
  }

  service.logInfoDto = LogInfoVo({ dashboardId, dashboardName })

  const action = RunSearchVo(service, namesMap)
  return action
}

export function createCrossTab(
  dashboardId: number,
  dashboardName: string,
  precision: PrecisionStrings,
  topicIds: number[],
  filter: any,
  metricSeriesList: SupportedMetricSeriesStrings[],
  timeUnits: MetricTimeUnitStrings[],
  options: any,
  propertySetterFunc: (serviceProperties: any) => any,
  isAudienceQuery: boolean
): RunSearch {
  const service = ServiceVo()
  service.type = ServiceType.CROSS_TAB
  service.parameters = ParamVo()
  service.properties = ServicePropertyVo()

  service.parameters.topicIds = topicIds
  if (precision) {
    service.parameters.precision = precision
  }
  service.parameters.filter = filter

  service.properties = propertySetterFunc(service.properties)

  service.properties.priority = 6
  let namesMap
  if (metricSeriesList) {
    service.properties.metricSeries = metricSeriesList
    if (isAudienceQuery) {
      namesMap = genAudienceMapping(metricSeriesList)
    }
  }

  if (options?.smoothing === false) {
    service.properties.smoothing = options.smoothing
  }

  service.properties.timeUnits = timeUnits
  service.logInfoDto = LogInfoVo({ dashboardId, dashboardName })

  const action = RunSearchVo(service, namesMap)
  return action
}

export function createMeasureMetric(
  dashboardId: number,
  dashboardName: string,
  precision: PrecisionStrings,
  topicIds: number[],
  filter: any,
  metricNames: string[],
  timeUnits: MetricTimeUnitStrings[],
  options: any
): RunSearch {
  // TODO: consider combining createMetric and createMeasureMetric
  const service = ServiceVo()
  service.type = ServiceType.MEASURE_METRIC_VALUE
  service.parameters = ParamVo()
  service.properties = ServicePropertyVo()

  if (topicIds && topicIds.length > 0) {
    service.parameters.topicIds = topicIds
  }
  if (options && options.previewTopic) {
    service.parameters.topicOnTheFly = options.previewTopic
  }
  if (precision) {
    service.parameters.precision = precision
  }

  service.parameters.filter = filter
  service.properties.priority = 6
  service.properties.timeUnits = timeUnits
  service.properties.metricNames = metricNames

  if (options && options.metricCategory) {
    service.properties.metricCategory = options.metricCategory
  }
  if (options && options.extraInfo) {
    service.properties.extraInfo = options.extraInfo
  }
  if (options && options.forceNotScale) {
    service.properties.forceNotScale = options.forceNotScale
  }
  if (options && options.isYoutubeOnly) {
    service.properties.youTubeOnly = true
  }

  service.logInfoDto = LogInfoVo({ dashboardId, dashboardName })

  const action = RunSearchVo(service)
  return action
}

/**
 * TODO: Seems redundent because it don't mutate input nor return anything
 * Sort by TimeUnit. Modify result in place.
 * @param {ServiceResultWith} result
 */
export function sortMetricResult(result: ServiceResultWith<AnnotatedMetricResult>): void {
  let idx: number
  let data: AnnotatedMetricResult
  let timeUnits: (MetricTimeUnitStrings | undefined)[]
  let metrics: Metric[]

  for (let i = 0; i < result.results.length; i += 1) {
    if (
      result.results![i]!.service!.type === ServiceType.METRIC_VALUE ||
      result.results![i]!.service!.type === ServiceType.MEASURE_METRIC_VALUE
    ) {
      timeUnits = result.results![i]!.service!.properties.timeUnits!
      data = result.results[i].data
      metrics = []

      for (let j = 0; j < data.metrics!.length; j += 1) {
        // TODO
        idx = timeUnits.indexOf(data.metrics?.[j].timeUnit as any)

        // sanity check
        if (idx === -1) {
          throw new Error('unknown time unit')
        }

        metrics[idx] = data.metrics![j]
      }

      data.metrics = metrics
    }
  }
}

/**
 * TODO: Seems redundent because it don't mutate input nor return anything
 * Round result. Modify result in place.
 * @param {ServiceResult} serviceResult
 */
export function roundMetricResult(serviceResult: ServiceResultWith<AnnotatedMetricResult>) {
  const result = cloneDeep(serviceResult)
  let data
  let metric
  let metricSeries

  for (let i = 0; i < result.results.length; i += 1) {
    data = result.results[i].data

    for (let j = 0; j < data.metrics!.length; j += 1) {
      metric = data.metrics![j]

      for (let k = 0; k < metric.dataset!.length; k += 1) {
        metricSeries = metric.dataset![k]

        for (let l = 0; l < metricSeries.set!.length; l += 1) {
          if (
            metricSeries.seriesName === MetricSeries.ENGAGEMENT_RATIO ||
            metricSeries.seriesName === MetricSeries.OVERALL_STAR_RATINGS_AVERAGE ||
            metricSeries.seriesName === MetricSeries.OVERALL_SURVEY_SCORES_AVERAGE
          ) {
            metricSeries.set![l] = Math.round(metricSeries.set![l]! * 10) / 10
          } else {
            metricSeries.set![l] = Math.round(metricSeries.set![l]!)
          }
        }
      }
    }
  }
  return result
}

/**
 * Round result. Modify result in place.
 * @param {ServiceResultWith} result
 */
export function roundCrossTabResult(serviceResult: ServiceResultWith<PivotResult>) {
  const result = cloneDeep(serviceResult)
  let data
  let metric
  let metricSeries

  for (let i = 0; i < result.results.length; i += 1) {
    data = result.results[i].data
    for (let j = 0; j < data.crossTabs!.length; j += 1) {
      const crosstab = data.crossTabs![j]

      for (let k = 0; k < crosstab.metrics!.length; k += 1) {
        metric = crosstab.metrics![k]

        for (let l = 0; l < metric.dataset!.length; l += 1) {
          metricSeries = metric.dataset![l]

          if (
            metricSeries.seriesName === MetricSeries.OVERALL_STAR_RATINGS_AVERAGE ||
            metricSeries.seriesName === MetricSeries.OVERALL_SURVEY_SCORES_AVERAGE
          ) {
            for (let m = 0; m < metricSeries.set!.length; m += 1) {
              metricSeries.set![m] = Math.round(metricSeries.set![m]! * 10) / 10
            }
          } else {
            for (let m = 0; m < metricSeries.set!.length; m += 1) {
              metricSeries.set![m] = Math.round(metricSeries.set![m]!)
            }
          }
        }
      }
    }
  }
  return result
}

export function setInsightCountOption(
  service: Service,
  insightCountOptions: Partial<InsightCountOptions>
) {
  const modifiedService = service // * to prevent adding  eslint-disable-next-line no-param-reassign in every line

  if (insightCountOptions.comparedTopicIds) {
    modifiedService.parameters.comparedTopicIds = insightCountOptions.comparedTopicIds
  }
  if (insightCountOptions.previewTopic) {
    modifiedService.parameters.topicOnTheFly = insightCountOptions.previewTopic
  }
  if (insightCountOptions.groupInfo) {
    modifiedService.properties.groupInfo = insightCountOptions.groupInfo
  }
  if (insightCountOptions.showPrimaryObject) {
    modifiedService.properties.showPrimaryObject = insightCountOptions.showPrimaryObject
  }
  if (insightCountOptions.sizeNeeded) {
    modifiedService.properties.sizeNeeded = insightCountOptions.sizeNeeded
  }
  if (insightCountOptions.multipleLevelSizeNeeded) {
    modifiedService.properties.multipleLevelSizeNeeded = insightCountOptions.multipleLevelSizeNeeded
  }
  if (insightCountOptions.isAuthorBased) {
    modifiedService.properties.hashedAuthorIds = insightCountOptions.isAuthorBased
  }
  if (insightCountOptions.exactCount) {
    modifiedService.properties.maxExactItem = insightCountOptions.exactCount
  }
  if (insightCountOptions.isDMA) {
    modifiedService.properties.dma = insightCountOptions.isDMA
  }
  if (insightCountOptions.emojiCategory) {
    modifiedService.properties.emojiCategory = insightCountOptions.emojiCategory
  }
  if (insightCountOptions.extraInfo) {
    modifiedService.properties.extraInfo = insightCountOptions.extraInfo
  }
  if (insightCountOptions.postActivityTimeZone) {
    modifiedService.properties.postActivityTimeZone = insightCountOptions.postActivityTimeZone
  }
  if (insightCountOptions.forceNotScale) {
    modifiedService.properties.forceNotScale = insightCountOptions.forceNotScale
  }
  if (insightCountOptions.groupMetrics) {
    modifiedService.properties.groupMetrics = insightCountOptions.groupMetrics
  }
  if (insightCountOptions.imageAnalysis) {
    // TODO: imageAnalysis not exist in schema
    // @ts-ignore
    modifiedService.properties.imageAnalysis = insightCountOptions.imageAnalysis
  }
  if (insightCountOptions.facetServiceProperties) {
    modifiedService.properties.facetServiceProperties = insightCountOptions.facetServiceProperties
  }
}

export function createInsightCount(
  dashboardId: number,
  dashboardName: string,
  precision: PrecisionStrings,
  topicIds: number[],
  filter: Filter,
  measure: MeasureStrings,
  categories: CategoryStrings[],
  insightCountOptions?: Partial<InsightCountOptions>
): RunSearch {
  const service = ServiceVo()

  service.type = ServiceType.INSIGHT_COUNT
  service.parameters = ParamVo()
  service.properties = ServicePropertyVo()

  if (precision) {
    service.parameters.precision = precision
  }
  if (!!topicIds && topicIds.length > 0) {
    service.parameters.topicIds = topicIds
  }
  service.parameters.filter = filter
  service.properties.priority = 6
  service.properties.sizeNeeded = DEFAULT_SIZE_NEEDED
  service.properties.measure = measure
  service.properties.categories = categories
  service.properties.localized = true
  service.properties.keepLongInsights = isAllInsights()

  if (insightCountOptions) {
    setInsightCountOption(service, insightCountOptions)
  }

  service.logInfoDto = LogInfoVo({ dashboardId, dashboardName })

  return RunSearchVo(service)
}

export function createSideBySide(
  dashboardId: number,
  dashboardName: string,
  precision: PrecisionStrings,
  topicIds: number[],
  filter: Filter,
  measure: MeasureStrings,
  categories: CategoryStrings[],
  propertySetterFunc: (serviceProperties: any) => any,
  insightCountOptions?: Partial<InsightCountOptions>
): RunSearch {
  const service = ServiceVo()

  service.type = ServiceType.SIDE_BY_SIDE
  service.parameters = ParamVo()
  service.properties = ServicePropertyVo()

  if (precision) {
    service.parameters.precision = precision
  }
  if (!!topicIds && topicIds.length > 0) {
    service.parameters.topicIds = topicIds
  }
  service.parameters.filter = filter
  service.properties.priority = 6
  service.properties.sizeNeeded = DEFAULT_SIZE_NEEDED
  service.properties.measure = measure
  service.properties.categories = categories
  service.properties.localized = true

  service.properties = propertySetterFunc(service.properties)

  if (insightCountOptions) {
    setInsightCountOption(service, insightCountOptions)
  }

  service.logInfoDto = LogInfoVo({ dashboardId, dashboardName })

  return RunSearchVo(service)
}

export function createFingerprintRetrieval(
  serviceType: ServiceTypeStrings,
  dashboardId: number,
  dashboardName: string,
  topicIds: number[],
  filter: Filter,
  precision: PrecisionStrings,
  sortBy: SortByStrings,
  size?: number,
  ignoreSentiment?: boolean,
  includeHeaderTweet?: boolean
) {
  const service = ServiceVo()

  service.type = serviceType
  service.parameters = ParamVo()
  service.properties = ServicePropertyVo()

  if (precision) {
    service.parameters.precision = precision
  }
  if (!!topicIds && topicIds.length > 0) {
    service.parameters.topicIds = topicIds
  }
  service.parameters.filter = filter

  service.properties.dedup = false
  service.properties.highlightInfo = true
  service.properties.peerCount = 1
  service.properties.priority = 6
  service.properties.sort = getSortKey(sortBy)
  service.properties.sortBy = sortBy
  service.properties.sizeNeeded = size
  service.properties.ignoreSentiment = ignoreSentiment
  if (includeHeaderTweet) {
    service.properties.includeHeaderTweet = true
  }
  service.logInfoDto = LogInfoVo({ dashboardId, dashboardName })

  return RunSearchVo(service)
}

export function createDocumentRetrieval(
  dashboardId: number,
  dashboardName: string,
  topicIds: number[],
  documentIds: string[],
  filter: Filter,
  precision: PrecisionStrings,
  sortBy: SortByStrings
) {
  const service = ServiceVo()

  service.type = ServiceType.DOCUMENT_RETRIEVAL
  service.parameters = ParamVo()
  service.properties = ServicePropertyVo()

  if (precision) {
    service.parameters.precision = precision
  }
  if (!!topicIds && topicIds.length > 0) {
    service.parameters.topicIds = topicIds
  }
  service.parameters.documentIds = documentIds
  service.parameters.notMatching = false
  service.parameters.projected = false
  service.parameters.filter = filter

  service.properties.dedup = false
  service.properties.highlightInfo = true
  service.properties.peerCount = 1
  service.properties.priority = 6
  service.properties.sort = getSortKey(sortBy)
  service.properties.sortBy = sortBy
  service.properties.localized = true
  service.properties.ignoreSentiment = false
  service.logInfoDto = LogInfoVo({ dashboardId, dashboardName })

  return RunSearchVo(service)
}

export function createSentenceRetrieval(
  dashboardId: number,
  dashboardName: string,
  topicIds: number[],
  sentenceInfos: SentenceInfo[],
  filter: Filter,
  precision: PrecisionStrings,
  sortBy: SortByStrings,
  size?: number,
  ignoreSentiment = false
) {
  const service = ServiceVo()

  service.type = ServiceType.SENTENCE_RETRIEVAL
  service.parameters = ParamVo()
  service.properties = ServicePropertyVo()

  if (precision) {
    service.parameters.precision = precision
  }
  if (!!topicIds && topicIds.length > 0) {
    service.parameters.topicIds = topicIds
  }
  service.parameters.sentenceInfos = sentenceInfos
  service.parameters.filter = filter

  service.properties.dedup = false
  service.properties.highlightInfo = true
  service.properties.peerCount = 1
  service.properties.priority = 6
  service.properties.sort = getSortKey(sortBy)
  service.properties.sortBy = sortBy
  service.properties.localized = true
  service.properties.ignoreSentiment = ignoreSentiment
  service.properties.sizeNeeded = size
  service.logInfoDto = LogInfoVo({ dashboardId, dashboardName })

  return RunSearchVo(service)
}

export function createTopSearch(
  dashboardId: number,
  dashboardName: string,
  precision: PrecisionStrings,
  topicIds: number[],
  filter: Filter,
  sizeNeeded: number,
  sortBy: SortByOptionsStrings,
  // TODO: should be modified in redefine ?
  serviceType: typeof ServiceType.SW_TOP_POST | typeof ServiceType.SW_TOP_LINKS
): RunSearch {
  const service = ServiceVo()
  service.type = serviceType
  service.parameters = ParamVo({ precision, topicIds, filter })
  service.properties = ServicePropertyVo({ priority: 6, sizeNeeded, sortBy })
  service.logInfoDto = LogInfoVo({ dashboardName, dashboardId })
  return RunSearchVo(service)
}

export function convertResult(
  serviceType: ServiceTypeStrings,
  namesMap: Map<string, string>,
  obj: unknown
): ServiceResultWith<EntryData> | null {
  const result = ServiceResultVo(obj)
  if (!result) return null

  switch (serviceType) {
    case ServiceType.INSIGHT_COUNT: {
      result.results!.forEach((serviceResultEntry) => {
        const entry = serviceResultEntry
        entry.data = postProcess(entry.data)
      })
      return result as ServiceResultWith<InsightCount>
    }
    case ServiceType.DOCUMENT_RETRIEVAL:
      return result as ServiceResultWith<DocumentRetrievalResult>
    case ServiceType.MEASURE_METRIC_VALUE:
    case ServiceType.METRIC_VALUE: {
      const metricData = MetricResultVo(result.results![0].data)

      if (!!metricData && !!namesMap && namesMap.size !== 0 && !!metricData.metrics) {
        metricData.metrics.forEach((metric) => {
          if (!metric.dataset || !Array.isArray(metric.dataset)) {
            return
          }

          metric.dataset.forEach((series) => {
            const metricSeries = series
            if (series.seriesName && namesMap.has(series.seriesName)) {
              // TODO: not sure
              // metricSeries.seriesName = namesMap.get(metricSeries.seriesName)
              metricSeries.seriesName = namesMap.get(series.seriesName)
            }
          })
        })
      }
      const convertedResult = result as ServiceResultWith<AnnotatedMetricResult>
      convertedResult.results[0].data = metricData
      sortMetricResult(convertedResult)
      const roundedResult = roundMetricResult(convertedResult)
      return roundedResult
    }
    case ServiceType.DOCUMENT_FINGERPRINT_RETRIEVAL:
    case ServiceType.GEO_TAG_DOC_FINGERPRINT_RETRIEVAL:
    case ServiceType.SW_TOP_POST:
    case ServiceType.SW_TOP_LINKS:
    case ServiceType.SW_PHOTO_CONCEPTS:
    case ServiceType.SENTENCE_RETRIEVAL:
    case ServiceType.SENTENCE_FINGERPRINT_RETRIEVAL:
    case ServiceType.NOD_SENTENCE_FINGERPRINT_RETRIEVAL:
      return result as ServiceResultWith<any>
    case ServiceType.CROSS_TAB: {
      // TODO:
      result.results!.forEach((resultObj) => {
        const data = PivotResultVo(resultObj.data)
        if (!!data && !!namesMap && namesMap.size !== 0 && !!data.crossTabs) {
          data.crossTabs.forEach((pivot) => {
            if (!pivot.metrics || !Array.isArray(pivot.metrics)) {
              return
            }
            // TODO: confirm
            // pivot.forEach((metric) => {
            pivot.metrics.forEach((metric) => {
              if (!metric.dataset) {
                return
              }
              if (!Array.isArray(metric.dataset)) {
                return
              }
              metric.dataset.forEach((series) => {
                if (series.seriesName && namesMap.has(series.seriesName)) {
                  // eslint-disable-next-line no-param-reassign
                  series.seriesName = namesMap.get(series.seriesName)
                }
              })
            })
          })
        }
        // eslint-disable-next-line no-param-reassign
        resultObj.data = data
      })
      const roundedResult = roundCrossTabResult(result as ServiceResultWith<PivotResult>)
      return roundedResult as ServiceResultWith<PivotResult>
    }
    case ServiceType.SIDE_BY_SIDE:
      result.results!.forEach((serviceResultEntry) => {
        const entryData = serviceResultEntry.data as SideBySideResult
        entryData.results = entryData.results?.map((resultObj) => ({
          ...resultObj,
          insightCount: postProcess(resultObj.insightCount)
        }))
      })
      return result as ServiceResultWith<SideBySideResult>
    case ServiceType.PAGINATION:
    case ServiceType.SW_MEDIA:
    case ServiceType.AM_MEDIA:
    case ServiceType.FACET_RETRIEVAL:
      return result as ServiceResultWith<any>
    default:
      return null
  }
}

export function createMediaSearch(
  dashboardId: number,
  dashboardName: string,
  topicIds: number[],
  filter: any,
  precision: PrecisionStrings,
  sortBy: SortByStrings,
  mediaDomains: MediaDomainStrings[],
  sizeNeeded: number,
  serviceType: ServiceTypeStrings,
  opt_imageAnalysis?: boolean
): RunSearch {
  const service = ServiceVo()
  service.type = serviceType
  service.parameters = ParamVo()
  service.parameters.topicIds = topicIds
  service.parameters.filter = filter
  if (precision) {
    service.parameters.precision = precision
  }

  service.properties = ServicePropertyVo()
  service.properties.sortBy = sortBy

  service.properties.mediaDomains = mediaDomains
  service.properties.sizeNeeded = sizeNeeded
  if (opt_imageAnalysis) {
    // TODO: imageAnalysis not exist in schema
    // @ts-ignore
    service.properties.imageAnalysis = true
  }

  service.logInfoDto = LogInfoVo({ dashboardId, dashboardName })

  const action = RunSearchVo(service)
  return action
}

export function createDocumentSearch(
  dashboardId: number,
  dashboardName: string,
  topicIds: number[],
  filter: Filter,
  precision: PrecisionStrings,
  sortBy: SortByStrings,
  size: number,
  ignoreSentiment?: boolean,
  imageAnalysis?: boolean
) {
  const service = ServiceVo()

  service.type = ServiceType.DOCUMENT_RETRIEVAL
  service.parameters = ParamVo()
  service.properties = ServicePropertyVo()

  if (precision) {
    service.parameters.precision = precision
  }
  if (!!topicIds && topicIds.length > 0) {
    service.parameters.topicIds = topicIds
  }
  service.parameters.notMatching = false
  service.parameters.projected = false
  service.parameters.filter = filter

  service.properties.dedup = false
  service.properties.highlightInfo = true
  service.properties.priority = 6
  service.properties.sort = getSortKey(sortBy)
  service.properties.sortBy = sortBy
  service.properties.sizeNeeded = size
  service.properties.ignoreSentiment = ignoreSentiment
  // TODO: imageAnalysis not exist in schema
  // @ts-ignore
  service.properties.imageAnalysis = imageAnalysis
  service.logInfoDto = LogInfoVo({ dashboardId, dashboardName })

  return RunSearchVo(service)
}

export function createPhotoSearch(
  dashboardId: number,
  dashboardName: string,
  topicIds: number[],
  filter: any,
  precision: PrecisionStrings,
  detectType: DetectTypeStrings,
  objectFilters: string[],
  sizeNeeded: number,
  serviceType: ServiceTypeStrings
): RunSearch {
  const service = ServiceVo()
  service.type = serviceType
  service.parameters = ParamVo()
  service.parameters.topicIds = topicIds
  service.parameters.filter = filter
  if (precision) {
    service.parameters.precision = precision
  }

  service.properties = ServicePropertyVo()
  service.properties.sizeNeeded = sizeNeeded
  // @ts-ignore
  service.properties.imageAnalysis = true

  service.properties.photoConceptServiceProperties = {} as PhotoConceptServiceProperty
  service.properties.photoConceptServiceProperties.detectType = detectType
  // @ts-ignore
  service.properties.photoConceptServiceProperties.objectFilters = objectFilters

  service.logInfoDto = LogInfoVo({ dashboardId, dashboardName })

  const action = RunSearchVo(service)
  return action
}
